import { render } from "./StrategyView.vue?vue&type=template&id=1507615a"
import script from "./StrategyView.vue?vue&type=script&lang=js"
export * from "./StrategyView.vue?vue&type=script&lang=js"

import "./StrategyView.vue?vue&type=style&index=0&id=1507615a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__